<script lang="ts">
	import { page } from '$app/state';
	import PopBox from './popBox.svelte';

	const theme = $derived(page.data.theme);
</script>

<div
	class={['slate-box', 'top-bar', theme]}
	style="flex-shrink: 1; display: flex; padding: 2em 1em; margin: 1.5em; align-items: center; gap: 1em"
>
	<PopBox style="font-size: 2em; margin: 0 1em; padding: 0.3em">
		<a href="/" style="color: black">murrax.dev</a>
	</PopBox>

	<span style="vertical-align: middle; font-size: 1.5em; width:fit-content; flex-shrink: 10;">
		Random Notes:
	</span>
	<div
		style="display: flex; gap: 1.5em; justify-content: space-around; flex-grow: 1; overflow-x: hidden; overflow-y:visible; max-width: 100%"
		class="header-notes-list"
	>
		{#each page.data.headerNotes as note}
			<PopBox
				style="vertical-align: bottom; padding: 0.5em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
			>
				<a
					href={`/garden/${note.title}`}
					style="color: black; text-overflow: ellipsis; overflow: hidden;white-space: nowrap; text-decoration: underline"
				>
					{note.title}
				</a>
			</PopBox>
		{/each}
	</div>
</div>
